/* eslint-disable camelcase */

/**
 * A Performance
 * @param {integer} id - Performance ID
 * @returns {Class} - Performance instance
**/

class Performance {
	constructor({
		id_date,
		start_date,
		timezone
	} = {}){
		this._id = id_date;
		this._start_date = start_date ? new Date(start_date) : null;
		this._timezone = timezone;
	}

	getKey() {
		return String(this._id);
	}

	getDate() {
		return this._start_date;
	}

	getIsoDate() {
		return this.getDate()+"Z";
	}

	getTimezone() {
		return this._timezone;
	}
}

export default Performance;
